import { Button } from '@framework/ui/atoms/Button';
import { GeneralModal } from '@framework/ui/elements/GeneralModal';
import { ViewModelTagOperation } from '@view-model/domain/view-model/ViewModelTagOperation';
import { useCallback } from 'react';
import { toast } from 'react-hot-toast';
import { useTranslation } from 'react-i18next';

type Props = {
  isOpen: boolean;
  onClose(): void;
  groupId: string;
  viewModelTagId: string;
  tagName: string;
  setTagRemoved: React.Dispatch<React.SetStateAction<boolean>>;
};

export const ViewModalTagRemoveConfirmModal: React.FC<Props> = ({
  isOpen,
  onClose,
  groupId,
  viewModelTagId,
  tagName,
  setTagRemoved,
}: Props) => {
  const { t } = useTranslation();

  const handleSubmit = useCallback(async () => {
    try {
      await ViewModelTagOperation.remove(groupId, viewModelTagId);
      toast.success(t('home.tag.removeModal.removeSuccess'));
      setTagRemoved(true);
    } catch (e) {
      toast.error(t('common.message.unknownError'));
      console.error(e);
    }
    onClose();
  }, [groupId, onClose, setTagRemoved, viewModelTagId, t]);

  return (
    <GeneralModal
      isOpen={isOpen}
      onClose={onClose}
      title={t('home.tag.removeModal.title')}
      submitButton={<Button onClick={handleSubmit}>{t('common.action.delete')}</Button>}
      cancelButton={
        <Button color="secondary" onClick={onClose}>
          {t('common.action.cancel')}
        </Button>
      }
    >
      <div>
        <p>
          {t('home.tag.removeModal.confirmTitle', { tagName })}
          <br />
          {t('home.tag.removeModal.confirmDescription')}
        </p>
      </div>
    </GeneralModal>
  );
};
